import { DATA_GRID_LAZY_PAGE_SIZE } from '@/components/DataGrid/definitions';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useDataGridFetcher } from '../useDataGridFetcher';
import { LIST_ALL_METADATA_FIELDS_QUERY_KEY } from './useListAllMetadataFields';

export const getListMetadataFieldsQueryKey = ({
  page,
  perPage,
  tenantId,
}: {
  page?: string | number;
  perPage?: string | number;
  tenantId?: string;
} = {}) => [
  LIST_ALL_METADATA_FIELDS_QUERY_KEY,
  {
    page: +(page ?? 1),
    perPage: +(perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
    tenantId,
  },
];

const queryFunction =
  ({ page, perPage, tenantId }: { page?: string | number; perPage?: string | number; tenantId?: string } = {}) =>
  () =>
    api.metadata.listMetadataFields({
      tenantId: tenantId ?? '',
      page: +(page ?? 1),
      perPage: +(perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
    });

export const useFetchListMetadataFields = () => {
  const { getTenantId } = useTenants();
  return useDataGridFetcher({
    queryKey: parameters => getListMetadataFieldsQueryKey({ tenantId: getTenantId(), ...parameters }),
    queryFn: parameters => queryFunction({ tenantId: getTenantId(), ...parameters }),
  });
};
